import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { AuthUserModel } from 'src/app/auth/auth-user.model';

@Component({
  selector: 'gdpr-dialog',
  templateUrl: './gdpr-dialog.component.html',
  styleUrls: ['./gdpr-dialog.component.scss']
})
export class GdprDialogComponent implements OnInit {

  faTimes = faTimes;
  gdprContent: string = null;
  gdprAccept = false;
  authenticatedUser: AuthUserModel;

  constructor(
    public dialogRef: MatDialogRef<GdprDialogComponent>,
    private translateService: TranslateService
  ) { }

  ngOnInit() {    
    this.gdprContent = this.translateService.instant('app.gdpr-dialog.content');
  }

  onOkClick(): void {
    this.dialogRef.close(true);
  }
}
